import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import OfficerHome from "./pages/OfficerHome";
import NewTransaction from "./pages/NewTransaction";
import Transactions from "./pages/Transactions";
import RateBoard from "./pages/RateBoard";
import Inventory from "./pages/Inventory";
import OwnerDashboard from "./pages/OwnerDashboard";
import Users from "./pages/Users";
import AuditLog from "./pages/AuditLog";
import Reports from "./pages/Reports";
import Expenses from "./pages/Expenses";
import Approvals from "./pages/Approvals";
import DailyRecap from "./pages/DailyRecap";
import Products from "./pages/Products";
import { Loader2 } from "lucide-react";

function Protected({ children, ownerOnly }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#EAB308]" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (ownerOnly && user.role !== "owner") return <Navigate to="/home" replace />;
  return <Layout>{children}</Layout>;
}

function Landing() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#EAB308]" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "owner" ? "/dashboard" : "/home"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<Protected><OfficerHome /></Protected>} />
          <Route path="/new" element={<Protected><NewTransaction /></Protected>} />
          <Route path="/transactions" element={<Protected><Transactions /></Protected>} />
          <Route path="/rates" element={<Protected><RateBoard /></Protected>} />
          <Route path="/inventory" element={<Protected><Inventory /></Protected>} />
          <Route path="/dashboard" element={<Protected ownerOnly><OwnerDashboard /></Protected>} />
          <Route path="/approvals" element={<Protected ownerOnly><Approvals /></Protected>} />
          <Route path="/recap" element={<Protected ownerOnly><DailyRecap /></Protected>} />
          <Route path="/products" element={<Protected ownerOnly><Products /></Protected>} />
          <Route path="/reports" element={<Protected ownerOnly><Reports /></Protected>} />
          <Route path="/expenses" element={<Protected ownerOnly><Expenses /></Protected>} />
          <Route path="/users" element={<Protected ownerOnly><Users /></Protected>} />
          <Route path="/audit" element={<Protected ownerOnly><AuditLog /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
